import { Injectable } from '@angular/core';
import {SchoolSubject} from "../interfaces/school-subject";
import {BehaviorSubject} from "rxjs";
import {SchoolSubjectsFilterItem} from "../search-filter/school-subjects-filter/school-subjects-filter-item";

@Injectable({
  providedIn: 'root'
})
export class SchoolSubjectService {

  schoolSubjectedLoaded = new BehaviorSubject(false);
  private _schoolSubjects: SchoolSubject[] = [];
  constructor() { }

  setAllSubjectsFromAPI(subjects: SchoolSubject[]) {
    this._schoolSubjects = subjects;
    this.schoolSubjectedLoaded.next(true);
  }

  getSubjectByID(id: number): SchoolSubject | null {
    const foundSubjects = this._schoolSubjects.filter((el) => {
      return el.id === id;
    });

    if(foundSubjects.length) return foundSubjects[0];
    return null;
  }

  mapRawSchoolSubject(rawData: any) : SchoolSubject {
    return {
      id: parseInt(rawData.id) ?? -1,
      abbreviation: rawData.abbreviation ?? '',
      name: rawData.name ?? ''
    }
  }

  getSubjectsFilterItems(schoolSubjects: SchoolSubject[]): SchoolSubjectsFilterItem[] {

    const options: SchoolSubjectsFilterItem[] = [];

    schoolSubjects.forEach((schoolSubject: SchoolSubject) => {
      options.push({
        filterValue: schoolSubject.id,
        title: schoolSubject.name,
        icon: '/assets/img/subject-icons/' + this.getSchoolSubjectIconById(schoolSubject.id),
        active: false
      });
    });

    return options;

  }

  getSchoolSubjectIconById(id: number): string {
    switch (id) {
        case 1:
            return "berufsberatung.svg";
        case 2:
            return "bewegung-sport.svg";
        case 3:
            return "biologie-umweltkunde.svg";
        case 4:
            return "chemie.svg";
        case 5:
            return "deutsch.svg";
        case 6:
            return "englisch.svg";
        case 7:
            return "bo-workshops.svg";
        case 8:
            return "geschichte.svg";
        case 9:
            return "geographie-wirtschaftskunde.svg";
        case 10:
            return "informatik.svg";
        case 11:
            return "berufsberatung.svg";
        case 12:
            return "mathematik.svg";
        case 13:
            return "physik.svg";
        case 14:
            return "religion.svg";
        case 15:
            return "persoenlichkeitstraining.svg";
        case 16:
            return "soziales-lernen.svg";
        case 17:
            return "bo-vortrag.svg";
        default:
            return "bildnerische-erziehung.svg";

    }
  }

}
